import React from "react";
import { GridRow } from "../../../../types/admin";
import { useAppDispatch, useAppSelector } from "../../../../app/store";
import {
    changeQuestionModal,
    deleteElement,
    deleteRow,
    saveSlideRows
} from "../../../../app/slices/modals/questionEditModal";
import { openModal } from "../../../../app/slices/modals/elementModal";
import SlideEditorBase from "../shared/SlideEditor";

const SlideEditor = ({ slideRows, content_id }: { slideRows: GridRow[], content_id: string }) => {
    const dispatch = useAppDispatch();
    const { languageTab } = useAppSelector((state) => state.questionEditModal);

    const handleChangeRows = (rows: GridRow[]) => {
        dispatch(changeQuestionModal({ slide_rows: rows }));
        dispatch(saveSlideRows({ content_id: content_id, slide_rows: rows }));
    };

    const handleDeleteRow = (rowId: string) => {
        if (rowId && content_id) {
            dispatch(deleteRow({ row_id: rowId, content_id: content_id }));
        }
    };

    const handleDeleteElement = (elementId: string) => {
        if (elementId && content_id) {
            dispatch(deleteElement({ element_id: elementId, content_id: content_id }));
        }
    };

    return (
        <SlideEditorBase
            slideRows={slideRows}
            languageTab={languageTab}
            onChangeRows={handleChangeRows}
            onDeleteRow={handleDeleteRow}
            onDeleteElement={handleDeleteElement}
            onOpenElementModal={(payload) => dispatch(openModal(payload))}
        />
    );
};

export default SlideEditor;
